;(function () {
  angular
    .module('contrast.date')
    .factory('csDateRangePickerService', [
      'TimeService',
      csDateRangePickerService
    ])

  function csDateRangePickerService(TimeService) {
    var service = {
      formatModelToView: formatModelToView
    }

    return service

    function formatModelToView(modelVal, time) {
      var format = time
        ? TimeService.getDateTimeFormat()
        : TimeService.getDateFormat()
      if (
        angular.isObject(modelVal) &&
        modelVal.startDate &&
        modelVal.endDate
      ) {
        var start = moment(modelVal.startDate, format)
        var end = moment(modelVal.endDate, format)
        return start.format(format) + ' - ' + end.format(format)
      }
      return undefined
    }
  }
})()
